import {
  FETCH_REGISTRATION,
  FETCH_REGISTRATION_FAILED,
  FETCH_REGISTRATION_SUCCESS
} from '../../types';

const initialState = {
  user: {},
  isLoading: false,
  errors: {},
  error: false
}


const fetchRegisterEmailReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_REGISTRATION:
      return {
        ...state,
        isLoading: true,
          user: action.payload
      }
      case FETCH_REGISTRATION_SUCCESS:
        return {
          ...state,
          isLoading: false,
            user: action.payload
        }
        case FETCH_REGISTRATION_FAILED:
          return {
            ...state,
            isLoading: false,
              errors: action.payload,
              error: true
          }
          default:
            return {
              ...state
            };
  }
}

export default fetchRegisterEmailReducer;
